import Decimal from 'decimal.js';

// Small prices retain digits from the first non-zero digit; larger prices use
// decimal places. Truncate for display only, without changing trading values.
export function priceDisplay(value, digits = 4) {
  if (value === null || value === undefined || value === '') return '0';
  try {
    const number = new Decimal(value);
    if (!number.isFinite()) return '—';
    if (number.isZero()) return '0';
    const places = number.abs().lt(1) ? Math.max(0, digits - 1 - number.e) : digits;
    const text = number.toFixed(places, Decimal.ROUND_DOWN)
      .replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1');
    return text.replace(/\.([0]{3,})(?=[1-9])/, (_, zeros) =>
      '.0' + String(zeros.length).replace(/\d/g, digit => '₀₁₂₃₄₅₆₇₈₉'[Number(digit)]));
  } catch (_) {
    return '—';
  }
}
